import { Theme } from '@wds/styles';
import { createUseStyles } from 'react-jss';

type StyleNames =
  | 'outline'
  | 'poweredByText'
  | 'brandingLogoContainer'
  | 'brandingLogo'
  | 'brandingText'
  | 'brandingTextInner'
  | 'disclaimer'
  | 'heroFormCta';
type StyleProps = { isPremium: boolean };

const useStyles = createUseStyles<StyleNames, StyleProps, Theme>(theme => ({
  outline: {
    background: ({ isPremium }) => (isPremium ? theme.palette.background.light : theme.palette.primary.main),
    boxShadow: '0px 2px 16px 0px rgba(0, 0, 0, 0.5)',
    borderRadius: 16,
    padding: [23, 58],
  },
  '@media (max-width: 479px)': {
    outline: {
      padding: [32, 24],
    },
  },
  poweredByText: ({ isPremium }) => ({
    color: isPremium ? theme.palette.text.dark : theme.palette.text.light,
    textAlign: 'center',
    fontSize: 15,
    margin: 0,
    lineHeight: 1.5,
    fontWeight: theme.type.fontWeight.regular,
  }),
  brandingLogoContainer: {
    height: 32,
    width: 207,
    marginLeft: 'auto',
    marginRight: 'auto',
    display: 'block',
  },
  brandingLogo: ({ isPremium }) => ({
    color: isPremium ? theme.palette.text.dark : 'auto',
    fill: isPremium ? theme.palette.text.dark : 'auto',
  }),
  brandingText: {
    padding: [theme.spacing[5], 0],
    textAlign: 'center',
  },
  brandingTextInner: ({ isPremium }) => ({
    color: isPremium ? theme.palette.text.dark : theme.palette.text.light,
    fontSize: 18,
    margin: 0,
    lineHeight: 1.5,
    fontWeight: theme.type.fontWeight.regular,
  }),
  disclaimer: {
    width: 212,
    color: theme.palette.text.darkMuted,
    fontSize: 10,
    lineHeight: 1.5,
    fontWeight: theme.type.fontWeight.regular,
    textAlign: 'center',
    margin: [46, 'auto', 0, 'auto'],
    '& a': {
      color: 'inherit',
      textDecoration: 'underline',
    },
  },
  heroFormCta: {
    paddingTop: 0,
  },
}));

export default useStyles;
